// src/components/PermissionGate.js
import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../utils/AuthContext';

export default function PermissionGate({
  permission,
  anyOf = [],
  allOf = [],
  fallback = null,
  showFallback = false,
  children,
}) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  let allowed = true;

  if (permission) {
    allowed = hasPermission(permission);
  }

  if (allowed && anyOf.length) {
    allowed = hasAnyPermission(anyOf);
  }

  if (allowed && allOf.length) {
    allowed = hasAllPermissions(allOf);
  }

  if (allowed) {
    return children;
  }

  if (fallback) {
    return fallback;
  }

  if (!showFallback) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-orange-200 bg-orange-50 p-5 text-orange-800">
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-5 w-5" />
        <div>
          <h3 className="font-semibold">Access restricted</h3>
          <p className="mt-1 text-sm">
            You do not have the required permission to view this section.
          </p>
        </div>
      </div>
    </div>
  );
}